<template>
	<ac-modal :title="'Pending Selections'" ref="modal">
		<template>
			<div class="row" v-if="hasPendingSelections">
				<div class="col-md-12">
					<div class="widget widget-content flex-container">
						<div class="col-md-12">
							<div class="row">
								<h4 class="text-center">Your Pending Selections</h4>
								<hr>
							</div>
						</div>
						<div class="col-md-12" v-for="item in combinedItems">
							<template v-if="item.planId>0 && item.providerEntityId>0">
								<div class="row">
									{{ item.providerName }}
									<div class="pull-right" v-if="showPricing">
										<span>{{ item.memberFeeMinusDiscount | currency }}</span>
									</div>

								</div>
								<div class="row">
									{{ item.planName }} Plan
									<br>
									Selected for {{ item.consumerName }}
									<span v-if="item.isUpcomingChange">
                                <br>
                                Effective: {{ upcomingChangesEffectiveDate | shortDate }}
                            </span>
									<hr>
								</div>
							</template>
						</div>

					</div>
				</div>
			</div>
		</template>
		<template slot="buttons">
			<ac-button type="button" class="btn btn-success btn-sm btn-block wl-btn-success" :action="continueWithSelections">
				Make Additional Selections
			</ac-button>
			<ac-button type="button" class="btn btn-primary btn-sm btn-block" :action="completeSelections">
				Continue to Checkout
			</ac-button>
			<ac-button type="button" class="btn btn-danger btn-sm btn-block wl-btn-danger" :action="cancelSelections">
				Cancel
			</ac-button>
		</template>
	</ac-modal>
</template>

<script>
	import {mapGetters} from 'vuex';

	export default {
		name: "PendingSelectionModal",
		props: {consumerId: Number},
		computed: {
			...mapGetters(['combinedItems', 'upcomingChangesEffectiveDate', 'hasPendingSelections']),
			...mapGetters({showPricing: 'globalSettings/showPricing'})
		},
		methods: {
			showModal() {
				this.$refs.modal.open();
			},
			continueWithSelections() {
				this.$emit("continueWithSelections", "");
				this.$router.push({name: "physicianSearch", params: {consumerId: this.consumerId}});
			},
			completeSelections() {
				this.$router.push({name: "checkoutPreview", params: {consumerId: this.consumerId}});
			},
			async cancelSelections() {
				await this.$store.dispatch('REMOVE_ALL_CART_ITEMS', this.consumerId);
				this.$emit("selectionsHaveBeenCanceled", "");
			}
		}

	}
</script>

<style scoped>

</style>